import script from "./PartyBuild.vue?vue&type=script&setup=true&lang=js"
export * from "./PartyBuild.vue?vue&type=script&setup=true&lang=js"

import "./PartyBuild.vue?vue&type=style&index=0&id=b0cac4da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0cac4da"]])

export default __exports__